module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "part-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _c('h1', {
    staticClass: "part_tit"
  }, [_c('span', [_vm._v("COMMENTARY ON ROMANS 9–16")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" In the latter half of his letter to the church in Rome, Paul addresses some complex questions regarding the implications of the gospel of Jesus Christ for both corporate and Christian life. With pastoral concern he elucidates Christ’s fulfillment of the Law and the Prophets, the thorny issue of the acceptance of the Gentiles and the rejection of the Jews who did not believe in Christ, Scripture’s definition of the church, and the relationship between Christians of varying understandings and giftings. Seeking to renew and preserve the church, the reformers read the apostle’s words carefully, prayerfully applying them to their own context: for example, the continued unbelief of some Jews, Catholic resistance to the free gospel of salvation in Christ apart from any human merit and the need to proclaim the gospel faithfully without encouraging arrogance or despair. Unsurprisingly, in these ancient sacred pages Reformation theologians and pastors are not disappointed; they find words “for our learning, that we through patience and comfort of the Scriptures might have hope” (Rom 15:4 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")]), _vm._v("). Even if this lofty subject matter—especially of God’s election and grace—overwhelms and transcends human reason, nevertheless every creature should be silent and marvel at God’s goodness and mercy in his acts of creation and redemption. “O Lord, I am not proud; I have no haughty looks. I do not occupy myself with great matters, or with things that are too hard for me. But I still my soul and make it quiet, like a child on its mother’s breast; my soul is quieted within me. O Israel, wait on the Lord, from this time forth for evermore” (Ps 131 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCP")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Prolegomena: Text, Theology and Traditions")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOR AND ")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY TO ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(". ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(": If you want to engage successfully in theology and the study of Sacred Literature and you do not want to dash against a closed or sealed passage of Scripture, then above all things you should learn to understand sin correctly. And the epistle to the Romans should be your door and key to holy Scripture, otherwise you will never reach a proper understanding and knowledge of Scripture. Once you have done this, however, you will understand what a great evil sin is and that on account of sin God sent his Son to blot out sin by the blood of the Son of God—that indescribable sacrifice. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURES ON ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENESIS")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN100",
      "id": "ap_NFIN100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DDRESSES THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAK AND THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRONG")]), _vm._v(". ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(": So that we may understand this epistle properly and clearly, we should know that the Romans to whom St. Paul writes were converted to Christ partially from the Jews and partially from the Gentiles. At that time there were many Jews living in every land, as Acts 17 shows, and especially in Rome. Now after the apostle has taught them faith and good works correctly in the whole epistle, he makes some exhortations at the end of the epistle. So that he may preserve them harmoniously in faith and good works, he takes up the reasons that might produce discord and separate them from the unity of the Spirit. There are two reasons that still today, as in "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("all times, strive against the unity of the Spirit, against faith and against good works. Therefore we must see them and note them well.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The first reason is that some Jewish converts, though they heard that in the New Testament all kinds of food, days, clothing, vessels, persons, places and manners are free; and that only faith makes us godly in God’s sight; and that the laws about eating meat and fish, about special days and clothes, about places and vessels, were entirely abolished—nevertheless their weak conscience and imperfect faith were still so severely ensnared because of long-standing customs that they could not use this freedom. They worried that they would sin if they acted differently than their previous customs.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Similarly, both Jews and Gentiles, because of the same weakness, dared not eat the bread and meat that had been offered to idols by unbelievers, even though it was for sale in the market and was sold there. They thought that if they ate they would be honoring the idols and denying Christ, though it was in truth nothing. All food is clean and a good creature of God, whether in the hands of Gentiles or Christians, whether offered to God or to the devil.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("On the other hand, the second reason is that those who knew these things and had a stronger faith did not pay attention to the weak, but used their freedom all too boldly and with contempt for the weak by eating and drinking without distinction whatever came before them, which was also correct. But it was incorrect that they did not avoid the weak, but confused them. When the weak saw that they were so bold, they could neither follow nor remain behind. If they followed, their weak conscience would stand in the way and say, “It is sin; do not do it.” If they did not follow, then their conscience again would stand in the way and say: “You are not a Christian, for you do not do what the other Christians do. Your faith must not be correct.” See, thus they could neither stay behind nor run ahead; whatever they did, their conscience was against them. Now, to act against conscience is the same as acting against faith and is a grievous sin. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTIL ")]), _vm._v("(1540): S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDAY IN ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVENT")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN101",
      "id": "ap_NFIN101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL AND ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHTEOUSNESS")]), _vm._v(". ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPP ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELANCHTHON")]), _vm._v(": It is very helpful to note when reading all of Scripture that there is a twofold righteousness. The first is a civil righteousness, for we will call it that for clarity’s sake, whenever human reason does good works or civil works. But human reason does not see any other righteousness than that. And so it deems that works of that kind suffice for our justification before God. But it does not value any other worship of God other than offering those civil works, such as not stealing, not killing, not lying, not committing adultery, obeying the authorities and restraining pleasures. And it has decided that God’s wrath is placated by such works. Meanwhile, it does not see the uncleanness of the human heart, that it has no fear of or trust in God, and that it has a sinful longing and evil desires of every kind. Therefore the godly have always been at odds with the world. The godly teach some other righteousness beyond that hypocrisy of works. The world, in contrast, teaches the hypocrisy of works to such a degree that it teaches that those works placate the wrath of God and justify a person before God.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("But the gospel shows a far different righteousness, which is called the righteousness of faith. For the gospel teaches that Christ, the Son of God, was given on our behalf and that righteousness in God’s eyes is believing that our sins are forgiven us for Christ’s sake, that is to say, that for Christ’s sake we are received into the Father’s grace. Meanwhile, the gospel makes clear our sins and condemns not only outward faults but also the uncleanness of the heart. It shows that the human heart is devoid of the fear of God and is devoid of trust in God. It shows the baseness of human desire inflamed with passion in our members. And so it says that we cannot placate God’s wrath by the hypocrisy of our works, and it shows us another righteousness "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("utterly hidden and unknown to the world, namely, what Paul calls the righteousness of faith. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT IN ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN102",
      "id": "ap_NFIN102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIEF ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFICULTIES OF ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIDERIUS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RASMUS")]), _vm._v(": But the difficulty of this letter equals and almost surpasses its utility. And this seems to me to be the case for three reasons in particular. First, nowhere else is the order of speech more confused; nowhere is the speech more split by the transposition of words; nowhere is the speech more incomplete through absence of an apodosis, about which Origen complains time and again, as he struggles and labors everywhere in difficulties of this kind."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN103",
      "id": "ap_NFIN103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Whether this should be attributed to Tertius, in his role as interpreter or as recorder, or to Paul himself, I leave to others to judge. Paul plainly acknowledges his inexperience in discourse, though he begs his ignorance to be excused. Furthermore, so far from aiming at a discourse composed by human skill, he actually thought that he ought to avoid it, lest it detract in any way from the glory of the cross. And for this reason Origen thought that it was superfluous to search for polished composition in Paul."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN104",
      "id": "ap_NFIN104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" . . . Another factor that contributed to these difficulties of the language was Hebrew, the idioms of which Paul is constantly bringing in, speaking Greek in such a way that nonetheless you sometimes recognize it is Hebrew.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The second cause of difficulty, in my opinion, is the obscurity of things that are hard to put into words; because of them, no other letter is handicapped by more frequent rough spots or is broken by deeper chasms. So much is this the case that he himself, having abandoned something that he had started to say, is compelled to exclaim at one point: “Oh, the depth of riches!” And furthermore as a prudent man he so touches on certain mysteries as to display them as though through a window only, accommodating his speech to the situation of the times and to the capacity of those to whom he writes. Paul knew and saw certain things that it was unlawful for one to say, and he knew to what extent milk and to what extent solid food were needed. He knew the stages of growth in Christ, and what had to be applied to each one. . . .")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("I believe that a third reason is his frequent and sudden change of masks, while he considers now the Jews, now the Gentiles, now both; sometimes he addresses believers, sometimes doubters; at one point he assumes the role of a weak man, at another of a strong man; sometimes that of a godly man, sometimes of an ungodly man. The result of all this is that the reader, wandering about as though in some kind of confusing labyrinth or winding maze, does not see very well whence he has entered or how he may leave. Origen, in my opinion not less truly than elegantly, compares Paul to a man who leads a stranger into some very powerful ruler’s palace: a confusing place, owing to various kinds of winding passageways and to the recesses from the rooms."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN105",
      "id": "ap_NFIN105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" However, from afar he displays certain things from a most abundant treasury of wealth; he brings some things closer, but is unwilling that others be seen. Often, moreover, after having entered in through one door, he exits through another, so that the stranger himself wonders where he has come from, where he is or what way he should go out.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Even the apostle Peter acknowledges this in his second letter, testifying that there are certain things hard to comprehend in the Pauline letters, which those who are not very learned and not very strong might distort to their own ruin. We for our part have attempted to remove the difficulties to the best of our ability, except for certain words that are so peculiar to the language of Paul that they cannot be expressed in more than one way; these for example: faith, grace, body, flesh, member, spirit, mind, feeling, to build and other of this kind that, although it was not possible to change outright, we have striven to soften as much as possible. But now let us hear the man himself, speaking like a Roman "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("to the Romans, no, rather, to all, in terms quite blunt and clear. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGUMENT OF ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN106",
      "id": "ap_NFIN106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Paul Turns His Attention to Questions of Election (of the Gentiles)")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BRUPT ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIFT IN ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN")]), _vm._v(": Paul begins to remove the offenses that might have diverted human minds from Christ. For the Jews, for whom he was appointed according to the covenant of the law, not only rejected him but also regarded him with contempt, and for the most part hated him. So one of two things seemed to follow: either there was no truth in the divine promise, or Jesus, whom Paul preached, was not the Lord’s Christ who had been promised to the Jews specifically. This twofold knot Paul fully unties in what follows. He, however, so handles this subject as to refrain from all bitterness against the Jews, lest he excoriate their minds. Still he concedes absolutely nothing to them that might harm the gospel. He allows them their privileges in such a way as not to detract anything from Christ. But he passes abruptly to this subject, so that there appears to be no connection to the discourse. He, however, so begins this new subject as if he had already mentioned it.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("It happened in this way: having finished handling doctrine, he turned his attention to the Jews, and being astonished at their unbelief as at something monstrous he burst out into this sudden proclamation, as if it were a subject he had already handled. Because there was no one who would not immediately have thought: “If this be the doctrine of the Law and the Prophets, how is it that the Jews so stubbornly reject it?” In addition, it was known everywhere that everything Paul had said so far about the law of Moses and the grace of Christ was more odious to Jews than that through their consent the Gentile’s faith should be nourished. It was therefore necessary to remove this obstacle, lest it should impede the advance of the gospel. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN107",
      "id": "ap_NFIN107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AND THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL OF THE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILES")]), _vm._v(". ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPP ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELANCHTHON")]), _vm._v(": An entirely new discussion is begun. Although he at times repeats and interweaves the doctrine of justification, he chiefly treats two other matters: Who truly are the people of God (or which is the true church), and the calling of the Gentiles. . . . There are at all times two bodies of the church, the one of the true church, the other of the one that has the title but that persecutes the true church. The church, which bears the title, has great authority, great power. Therefore, lest the weak be deceived, it is necessary that the godly be fortified against this external appearance in order that they may understand which is the true church, who are the true people of God.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is also now being argued:")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Major Premise:")]), _vm._v(" The church cannot err.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Minor Premise:")]), _vm._v(" The assembly of the bishops and priests and of their adherents is the church.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Conclusion:")]), _vm._v(" Therefore this assembly cannot err.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("They prove the minor premise by the fact that for many centuries these alone were in the ministry of the Word; they have the examples of the fathers, etc., so they are the church. Here it is necessary to show that although they hold the position of the ministry, they do not have the ministry of the gospel if they teach wicked things, and neither are they the church. It is not a small offense that this highest honor—the title of church—is taken from popes, princes and all the most beautifully ordered clerical estate and this august title is conferred on a few who are poor and calamity-ridden, and who indeed seem to be rebelliously shouting against the ordinary form of the church. By this offense many "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("are being scared away from the gospel and from the true church. Therefore people must be taught about election, that the true church is not any and every crowd, but those who are elected and called to the gospel, who retain the true Word of God and fight for it against the wisdom and power of the world.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("That is the occasion for Paul’s discussion here. For the Jews were pressing these two arguments, that they were the people of God, and unless things were better for the entire Jewish state, the promises had not yet been fulfilled. Similarly, because they are the seed of Abraham, the promise does not pertain to the Gentiles. Here Paul opposes a contrary statement, that the people of God is a certain multitude chosen through mercy, called through the gospel and sanctified through the Holy Spirit. The people of God are not made by fleshly propagation and the worship of the law. This is the sum and substance of the statement and the principal proposition. Therefore he is speaking of the effect of election, that the true church has been elected through mercy, and he takes away two causes, fleshly propagation and the law.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Here he argues about predestination, about the freedom of the human will and about certain other matters—the general and the special activity of God and contingency. It is useful to consider the things that are said about such great matters, but those things are to be chosen piously and in the fear of God, since they are taught in the Scriptures, have the testimony of received and approved writers, and are profitable for consciences. . . . The writers do not disagree about the reprobation of the wicked, but all confess that the cause of reprobation in those who are damned is their wicked will and their sins. However, in the matter of the cause of predestination or election of those who are to be saved, they do not speak in the same way. . . .")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The mercy of God is the cause of election, as Paul clearly teaches here and elsewhere: If it is of works, it is no longer of grace. For the church is not dependent on human counsel or on human powers, but God in Christ loved and chose those who are to be saved. Here two questions about election torment the mind. The first is about worthiness or merit. The mind argues: If I were worthy, sufficiently pure or had merited well, I would declare that I also would receive mercy and the other benefits that have been promised. This trial arises from the judgment of the law, which requires worthiness and merits. Here it is very useful to hold fast to the teaching of the gospel about gratuitous mercy. The gospel of gratuitous mercy is proclaimed not to drive minds to despair, but in order that it might be a remedy for our mistrust and despair. And mercy is shown not in order that we might do nothing, or so that we might not accept the Word, but in order that our worthiness might be taken away and that the benefit of God might be certain.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("The other cause of unrest comes from particularity. Because we hear that mercy is the cause of election, and that few are elected, we experience even greater anguish and wonder whether God shows partiality. Why does he not have mercy on all? To this attack also there should be opposed the universal promises of the gospel, which teach that God offers salvation to all on account of Christ and freely, according to the passage: “The righteousness of God through faith in Jesus Christ on all and over all.” And elsewhere: “The same Lord of all is rich toward all.” Likewise: “Everyone who will call on the name of the Lord,” etc. These universal statements must be opposed to the temptation stemming from particularity. Thereafter we must declare that one must not judge about the will of God from reason without the Word of God. Likewise, just as about justification, so also about election, one must not judge from reason or from the law, but from the gospel.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("When we wonder: if merits make no difference, then why is not mercy shown to all? I answer: As far as the Word and the promise are concerned, we must hold fast to universality. But not all attain the benefits because very many people resist the Word. And it is evident that resistance is an act of the human will, because God is not a cause of sin.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("If we speak for the benefit of the conscience according to our judgment, let us say as we say about justification: That those who believe are righteous, so the elect do not resist the calling, but ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("believe the gospel, and do not in the end reject it. Nevertheless, it must be held in the meantime that to believe and not to resist are results that come about when the Holy Spirit impels. I am speaking about our judgment, which does not search out the hidden majesty without the Word, but looks at the God who calls through the promise and apprehends his will in the Word, which is universal. Thus Paul says: “It is not of him who wills and runs, but of God who has mercy”; that is, mercy is indeed the cause of election, not our willing and running. Nevertheless, these things are done in the will and in running, not in resisting. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("(1540).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN108",
      "id": "ap_NFIN108-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFINING ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMS")]), _vm._v(": F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREKNOWLEDGE, ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVIDENCE AND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDESTINATION")]), _vm._v(". ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILEMANN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSHUS")]), _vm._v(": The foreknowledge of God is the name for God’s infinite wisdom and knowledge, by which he foresees and observes from eternity all the things that will be—evil as well as good—no less than he sees present things, nor is any outcome of events able to be hidden from him. “I am God,” he says in Isaiah 46, “who from the beginning announces the latter things, and from the very origin those things that have not yet occurred. I speak and it is deemed my counsel, and I do whatever I will.”")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("But providence is the name for the divine reason and care with which he upholds and governs this entire world, holds individual creatures in his hand and will, governs all things in accordance with his good will and divine counsel, gathers the church in the world, rules the saints by his Spirit, permits the wicked to behave wantonly for a while (until he appoints a boundary and a limit for them), helps good things and honors them with rewards, permits evils and punishes them. David describes this providence with these words: “The Lord looked down from heaven; he saw all the children of men. From his well-furnished dwelling he looked down on all who dwell on earth. He makes their hearts one by one; he understands all their works” (Psalm 33). Again, Matthew 10: “All the hairs of your head are numbered.”")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("But election ("), _c('i', [_vm._v("eklogē")]), _vm._v(") or predestination, or the determination beforehand ("), _c('i', [_vm._v("prohorisis")]), _vm._v("), or the purpose ("), _c('i', [_vm._v("prothesis")]), _vm._v(") or a foreordaining ("), _c('i', [_vm._v("taxis")]), _vm._v(") is the eternal counsel of God by which before the foundation of the world, without any respect to people’s merits or works, but purely out of his immense mercy in his Son Jesus Christ he chose for himself a certain number of people, whom he intended to call according to the good pleasure of his will through the preaching of the gospel and to lead by faith to eternal life and glory and decided to leave the remaining multitude of fallen people to their destruction. Thus Luke says in Acts 13: “And as many as had been appointed to eternal life believed.” And Paul says in Ephesians 1: “Through whom we also were adopted as it was appointed, predestined according to his purpose, who works all things according to the counsel of his will.” It is concerning this election that we are now concerning ourselves. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDESTINATION OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTS")]), _vm._v(": D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFINING ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMS")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN109",
      "id": "ap_NFIN109-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOULD THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCTRINE OF ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LECTION ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUGHT? ")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILEMANN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSHUS")]), _vm._v(": All the articles of faith, but especially this doctrine about the election of the saints, are a mystery hidden to the entirety of human reason and far exceeds every capacity of human genius. Consequently, it must be sought, learned and drawn not from the books of the philosophers or the pleasing arguments of the wise of this world, but only from the Word of God, in which God has revealed out of his immense kindness his hidden mysteries, that is, as much as he wanted us to know. The Baptist"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN110",
      "id": "ap_NFIN110-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" says, "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“Nobody has ever seen God; the only-begotten Son who is in the bosom of the Father, he himself has made him known to us” (Jn 1). Again, “Nobody knows the Father except the Son” (Mt 11). . . . Therefore let us remember that our minds ought to be called away from those arguments that human reason admires, when we think about election. For what would be more foolish than from ignorant and blind reason to cobble together and invent the hidden and eternal counsel of God concerning how the church of the saints is gathered? As if there would be more wisdom and righteousness in filthy humanity than in the most holy God!")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Therefore let us hear God with all reverence as he testifies about his own act of election and reveals the mysteries of his will. And let us recognize that whatever is not revealed in express words by the Son of God, the apostles and the prophets is not only uncertain but also clearly false, and abusive against the divine majesty. David says, “[Your word] is a light to my feet.” This principle ought to hold sway in every aspect of religion, but especially in this article. Nor will we be ashamed to admit a humble and godly ignorance in those matters in which investigation is audacious and the presumption of knowledge is harmful.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("God does not begrudge us the unapproachable light of his hidden wisdom, but he considers our weakness, which cannot endure the infinite splendor of his divine majesty. He said to Moses, “You cannot see my face, for no human being will see me and live.” Therefore let us rather thank God because he has not concealed anything of those matters that pertain to our obtaining eternal salvation, but has revealed all things most clearly through his Son. But he has removed far from our sight for our own advantage those things that can be left unknown without any loss to our salvation and that we cannot perceive or endure in the fragility of this life.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("After we have warned that this doctrine about the predestination of the saints ought to be drawn only from the fonts of Israel, one must now add in what order that doctrine ought to be set forth before people. By all means we must take care that consciences that have not yet been instructed in necessary doctrine and confirmed in the very beginnings of religion not be snatched away in the stormy treatment of this doctrine into labyrinths of arguments from which they cannot escape.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN111",
      "id": "ap_NFIN111-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("“I spoke to you as to infants in Christ; I gave you milk to drink,” said Paul. Therefore the mental capacity of the hearers must be taken into consideration. And he teaches us by his own example in this epistle when is the time to set forth this doctrine. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDESTINATION OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AINTS")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURCE AND ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RDER OF ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCTRINE")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN112",
      "id": "ap_NFIN112-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b660ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1dev1.vue
// module id = 84
// module chunks = 0